import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { memo, useMemo } from 'react';
import './Tooltip.scss';
import { jsxs, jsx } from 'react/jsx-runtime';

function Tooltip(_ref) {
  var className = _ref.className,
    placement = _ref.placement,
    arrowPlacement = _ref.arrowPlacement,
    bgColor = _ref.bgColor,
    children = _ref.children;
  var cssPropertyArrowInner = useMemo(function () {
    return "border".concat(placement[0].toUpperCase()).concat(placement.slice(1), "Color");
  }, [placement]);
  var arrowInnerStyle = useMemo(function () {
    return _defineProperty({}, cssPropertyArrowInner, bgColor);
  }, [bgColor, cssPropertyArrowInner]);
  var tooltipContentStyle = useMemo(function () {
    return {
      backgroundColor: bgColor
    };
  }, [bgColor]);
  return /*#__PURE__*/jsxs("div", {
    className: "dtv-common-c-general-tooltip dtv-common-c-general-tooltip--".concat(placement, "-arrow-").concat(arrowPlacement, " ").concat(className),
    children: [/*#__PURE__*/jsx("span", {
      className: "dtv-common-c-general-tooltip__arrow",
      children: /*#__PURE__*/jsx("span", {
        className: "dtv-common-c-general-tooltip__arrow-inner",
        style: arrowInnerStyle
      })
    }), /*#__PURE__*/jsx("div", {
      className: "dtv-common-c-general-tooltip__content",
      style: tooltipContentStyle,
      children: children
    })]
  });
}
Tooltip.defaultProps = {
  className: '',
  bgColor: '',
  children: [],
  arrowPlacement: 'center'
};
var Tooltip$1 = /*#__PURE__*/memo(Tooltip);

export { Tooltip$1 as default };
//# sourceMappingURL=Tooltip.js.map
